import React, { memo, useRef, useState } from "react";
import UploadDragDocument from "../../global/UploadDocument/UploadDragDocument";
import DragAndDrop from "../../global/DragAndDrop/DragAndDrop";
import { uploadFiles } from "../../../features/uploadDocument/uploadDocumentSlice";
import { useDispatch, useSelector } from "react-redux";
import { authLoginSelector } from "../../../features/auth/authLoginSlice";
import { orderLawyerInfoSelector } from "../../../features/auth/orderLawyerInformationSlice";
import UploadedFile from "./UploadedFile";
import { convertToBase64, formatDocumentUploadBase64StringByDocumentType, logUnAcceptedFiles } from "../../../common/utils";
import { UploadDocumentAcceptedTypesStringConstants, UploadDocumentTypesArrayConstansts } from "../../../common/constants";
import { toast } from "react-toastify";

function RequiredDocument({
  control,
  Controller,
  setValue,
  trigger,
  error,
  fieldName,
  value,
  t,
  index,
  name = "",
  date = "",
  propertyIndex,
  form = false,
  isSingleDoc = false,
  isDeleteDialogRequired = false,
  isSubmitButtonRequired = false,
  propertyList,
  isSameProperty,
  hideAllProperties,
  showDate,
  summaryPage,
  hasValue,
  setHasValue,
  requiredDocument,
  activeRequiredDocumentIndex,
  setActiveRequiredDocumentIndex,
}) {
  const [hideProperty, setHideProperty] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const dispatch = useDispatch();
  const { userLogin } = useSelector(authLoginSelector);
  const { postOrderDetailsInfo } = useSelector(orderLawyerInfoSelector);
  const fileUpload = useRef(null);
  const property = propertyList && propertyList[propertyIndex - 1];
  const { address1, cityTown, address2, provinceState, postalZip } =
    property || {};

  const fullAddress = `${address1 || ''} ${address2 || ''}, ${cityTown || ''}, ${provinceState || ''} ${postalZip || ''}`

  // address1
  //   ? address1
  //   : `${address2 ? address2 + "," : ""}${cityTown ? cityTown + "," : ""}${
  //       provinceState ? provinceState + "," : ""
  //     }${postalZip || ""}`;

  const handleButtonClick = () => {
    fileUpload.current.click();
  };

  async function changeFieldThisOrder(name, val, field) {
    const nextFiles = [...val];
    field?.onChange(nextFiles);
    setValue && setValue(name, nextFiles);
    trigger && trigger(name);

    if (!val?.length) return;

    let Base64String = await convertToBase64(val[0]);
    Base64String = formatDocumentUploadBase64StringByDocumentType(val[0]?.type, Base64String)
    setUploadedFiles([
      {
        name: val[0]?.name,
        val: val,
        field: field,
        storageFileID: value?.document?.filter((item) =>
          item?.name?.includes(val[0]?.name)
        )?.storageFileID,
        Base64String: Base64String,
      },
    ]);
  }

  async function SubmitDocuments(name, val, field) {
    // let req = formRequestToUpload(name, val, field);
    let req = {};
    req.FileID = postOrderDetailsInfo?.fileID;
    req.DocumentFileName = val[0].name;
    req.UserID = userLogin?.userId;
    req.IsPublic = true;
    req.DocumentType = value?.documentType || "Other";
    req.SectionName = "RequiredDocument";
    req.FileNumber = postOrderDetailsInfo?.fileNumber;
    req.Notes = "";
    req.DocStoreId = 1;
    req.fileproblemId = value?.fileProblemID || 0;
    req.propertyID = value?.propertyID || 0;
    req.fileProblemChecksID = parseInt(value?.fileProblemChecksID) || 0;

    dispatch(
      uploadFiles(
        req,
        val[0]?.name,
        fieldName,
        val,
        {
          setValue,
          trigger,
          field,
        },
        isSingleDoc
      )
    );
    setHasValue && setHasValue(false);
    if (fileUpload.current) {
      fileUpload.current.value = '';
    }

    setUploadedFiles([])
  }

  return form ? (
    <div className="px-[40px]">
      <div
        className="border-[#D9D9D9] border-b  pb-4 pt-4"
        style={{ paddingBottom: value?.document?.length > 0 && "4rem" }}
      >
        <Controller
          control={control}
          name={fieldName}
          defaultValue={null}
          render={({ field }) => {
            const isCurrentIndexActive = activeRequiredDocumentIndex === index;
            const shouldDisableUploadButton = requiredDocument
              ? !hasValue
                ? false
                : activeRequiredDocumentIndex == null
                  ? field?.value?.length === 0
                    ? true
                    : false
                  : isCurrentIndexActive
                    ? false
                    : true
              : false;

            return (
            <>
              <div className="flex flex-row">
                <input
                  type="file"
                  ref={fileUpload}
                  onChange={(e) => {
                    const acceptedFilesUnfiltered = [...e.target.files];
                    const acceptedFiles = acceptedFilesUnfiltered.filter(
                      ({ type }) => UploadDocumentTypesArrayConstansts?.includes(type)
                    );
                    // Log unsupported file types
                    logUnAcceptedFiles(acceptedFilesUnfiltered, { toast }, t)
                    summaryPage
                      ? changeFieldThisOrder(
                        fieldName,
                        [...acceptedFiles],
                        field
                      )
                      : SubmitDocuments(fieldName, [...acceptedFiles], field);
                    if (setActiveRequiredDocumentIndex && acceptedFiles?.length > 0) {
                      setActiveRequiredDocumentIndex(index);
                    }
                    setHasValue && acceptedFiles?.length > 0 && setHasValue(true);
                  }}
                  accept={UploadDocumentAcceptedTypesStringConstants}
                  multiple
                  style={{ display: "none" }}
                />
                <div className="flex flex-col items-start pr-[40px] w-[392px]">
                  <div className="flex flex-row font-[600] ">
                    {uploadedFiles && uploadedFiles?.length === 0 && (
                      <div className="flex flex-col">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="relative top-0 "
                          width="30"
                          height="22"
                          fill="none"
                        >
                          <g
                            clipPath="url(#clip0_2775_161095)"
                            stroke="#E2211C"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M10.995 20.17a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.333ZM11 7.336v3.667M11 14.664h.01" />
                          </g>
                          <defs>
                            <clipPath id="clip0_2775_161095">
                              <rect width="30" height="22" fill="#fff" />
                            </clipPath>
                          </defs>
                        </svg>

                      </div>
                    )}
                    <div className="flex flex-col">
                      {name}
                    </div>
                  </div>
                  <br />
                  <DragAndDrop
                    onDrop={(acceptedFiles) => {
                      const pdfFiles = acceptedFiles.filter(
                        ({ type }) => UploadDocumentTypesArrayConstansts?.includes(type)
                      );
                      // Log unsupported file types
                      logUnAcceptedFiles(acceptedFiles, { toast }, t)
                      changeFieldThisOrder(fieldName, [...pdfFiles], field);
                      if (setActiveRequiredDocumentIndex && pdfFiles?.length > 0) {
                        setActiveRequiredDocumentIndex(index);
                      }
                      setHasValue && pdfFiles?.length > 0 && setHasValue(true);
                    }}
                    name={fieldName}
                    t={t}
                    summaryPage={summaryPage}
                    disabled={shouldDisableUploadButton}
                  />
                  <br />
                </div>
                {!isSameProperty && (
                  <div className="flex items-center mr-10 w-[167px] mb-6">
                    {propertyIndex != -1 ? (t("property") + " " + propertyIndex + " - " + fullAddress) : "For this order"}
                  </div>
                )}
                {
                  <div className="flex items-center w-[25%] mb-6">
                    {showDate ? date : ""}
                  </div>
                }
                <div className="flex items-center justify-end w-[25%]">
                  <button
                    type="button"
                    className="btn__icon-file"
                    onClick={handleButtonClick}
                    disabled={shouldDisableUploadButton}
                  >
                    <span>{t("uploadDocument")}</span>
                    <svg
                      aria-hidden="true"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <line
                        x1="4"
                        y1="10.6816"
                        x2="16"
                        y2="10.6816"
                        stroke="#231F20"
                        strokeWidth="2"
                        strokeLinecap="round"
                      ></line>
                      <line
                        x1="10"
                        y1="4.5"
                        x2="10"
                        y2="16.5"
                        stroke="#231F20"
                        strokeWidth="2"
                        strokeLinecap="round"
                      ></line>
                    </svg>
                  </button>
                  <input
                    className="hidden"
                    id="file_input4"
                    type="file"
                    aria-label="Upload Document"
                  />
                </div>
              </div>
              {summaryPage
                ? uploadedFiles &&
                uploadedFiles.length > 0 &&
                uploadedFiles.map((item, index) => (
                  <UploadedFile
                    name={item.name}
                    index={index}
                    isDocType={0}
                    deleteFile={(name) => {
                      field.onChange(
                        field.value.filter((it) => it.name !== name)
                      );
                      SubmitDocuments(fieldName, [
                        ...field.value.filter((it) => it.name !== name),
                      ]);
                      if (fileUpload.current) {
                        fileUpload.current.value = '';
                      }
                      setHasValue && setHasValue(false);
                      setActiveRequiredDocumentIndex && setActiveRequiredDocumentIndex(null);
                    }}
                    popFile={(name) => {
                      setUploadedFiles(
                        uploadedFiles?.filter(
                          (item) => item?.name !== name
                        )
                      )
                      if (fileUpload.current) {
                        fileUpload.current.value = '';
                      }
                      setHasValue && setHasValue(false);
                    }
                    }
                    file={item}
                    title={item.name}
                    t={t}
                    docName={name}
                    value={item?.val}
                    field={item?.field}
                    propertyList={propertyList}
                    propertyNumber={value?.name?.split(" ")[1]}
                    isSubmitButtonRequired
                    summaryPage={summaryPage}
                    SubmitDocuments={SubmitDocuments}
                    requiredDocument
                    form
                  />
                ))
                : value &&
                value?.document?.length > 0 &&
                value?.document?.map((item, index) => (
                  <UploadedFile
                    name={item.name}
                    index={index}
                    isDocType={0}
                    deleteFile={(name) => {
                      field.onChange(
                        field.value.filter((it) => it.name !== name)
                      );
                      changeFieldThisOrder(fieldName, [
                        ...field.value.filter((it) => it.name !== name),
                      ]);
                      if (fileUpload.current) {
                        fileUpload.current.value = '';
                      }
                      setHasValue && setHasValue(false);
                      setActiveRequiredDocumentIndex && setActiveRequiredDocumentIndex(null);
                    }}
                    file={item}
                    title={item.name}
                    t={t}
                    docName={name}
                    value={item?.val}
                    field={item?.field}
                    propertyList={propertyList}
                    propertyNumber={value?.name?.split(" ")[1]}
                    isSubmitButtonRequired
                    summaryPage={summaryPage}
                    SubmitDocuments={SubmitDocuments}
                    form
                  />
                ))}
            </>
          );
          }}
        />
      </div>
    </div>
  ) : (
    <>
      <div
        id="accordion-purchaser-individual"
        data-accordion="open"
        className="flex flex-flow justify-between items-center custom__accordion simple mb-12"
      >
        {!isSameProperty && (
          <>
            {/* <h4 className="font-normal">
              <b>{value?.name}</b>
            </h4> */}

            {/* <h2 id={`accordion-purchaser-individual-heading-${index}`}>
              <button
                className="flex flex-flow font-semibold text-secondary-red custom__accordion-header"
                type="button"
                aria-expanded={!hideProperty}
                data-accordion-target={`#accordion-purchaser-individual-body-${index}`}
                onClick={() => setHideProperty((prev) => !prev)}
              >
                {error?.document && (
                  <>
                    <img
                      src="../../images/alert-circle.cd312933.svg"
                      aria-hidden="true"
                      className="mr-2"
                      alt="alert icon"
                    />
                    <p className="text-secondary-red">
                      1 {t("DocumentMissing")}
                    </p>
                  </>
                )}
                <svg
                  className="relative left-2 w-[25px]"
                  aria-hidden="false"
                  data-accordion-icon
                  fill=""
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </h2> */}
          </>
        )}
      </div>

      <div
        id={`accordion-purchaser-individual-body-${index}`}
        style={{
          display: isSameProperty
            ? hideAllProperties
              ? "none"
              : ""
            : hideProperty
              ? "none"
              : "",
        }}
      // aria-labelledby={`accordion-purchaser-individual-heading-${index}`}
      >
        <UploadDragDocument
          fieldName={`${fieldName}.document`}
          control={control}
          Controller={Controller}
          trigger={trigger}
          setValue={setValue}
          inline
          documentName={value.message}
          sectionName="RequiredDocument"
          propertyId={value.propertyID}
          fileproblemId={value.fileProblemID}
          isSingleDoc={isSingleDoc}
          isDeleteDialogRequired={isDeleteDialogRequired}
          isSubmitButtonRequired={isSubmitButtonRequired}
          propertyList={propertyList}
          propertyNumber={value?.name?.split(" ")[1]}
          hasValue={hasValue}
          setHasValue={setHasValue}
          requiredDocument={requiredDocument}
          documentType={value?.documentType}
          fileProblemChecksID={value?.fileProblemChecksID || 0}
        />
      </div>
    </>
  );
}

export default memo(RequiredDocument);
